<template>
  <div ref="element" :class="$style.canvas">
    <positionable
        :x="symbolX"
        :y="symbolY"
        ref="positionable"
        @resized.once="setInitialSymbolPosition">
      <currency-symbol></currency-symbol>
    </positionable>
  </div>
</template>

<script>
import calculateCollision from '@/calculateCollision';
import calculateNewPosition from '@/calculateNewPosition';
import CurrencySymbol from '@/components/CurrencySymbol';
import Positionable from '@/components/Positionable';
import Window from '@/Window';

export default {
  name: 'app',
  components: {
    CurrencySymbol,
    Positionable,
  },

  data() {
    return {
      symbolX: 0,
      symbolY: 0,
      window: new Window(window),
    };
  },

  methods: {
    checkCollision() {
      const collision = calculateCollision({
        objectX: this.symbolX,
        objectY: this.symbolY,
        objectWidth: this.$refs.positionable.width,
        objectHeight: this.$refs.positionable.height,
        mouseX: this.window.mouseX,
        mouseY: this.window.mouseY,
      });

      if (collision) {
        this.moveSymbol();
      }
    },

    moveSymbol() {
      const { x, y } = calculateNewPosition({
        windowWidth: this.window.innerWidth,
        windowHeight: this.window.innerHeight,
        objectWidth: this.$refs.positionable.width,
        objectHeight: this.$refs.positionable.height,
        mouseX: this.window.mouseX,
        mouseY: this.window.mouseY,
      });

      this.symbolX = x;
      this.symbolY = y;
    },

    setInitialSymbolPosition() {
      this.$nextTick(() => {
        this.symbolX = (this.window.innerWidth / 2) - (this.$refs.positionable.width / 2);
        this.symbolY = (this.window.innerHeight / 2) - (this.$refs.positionable.height / 2);
      });
    },
  },

  watch: {
    'window.innerWidth': function windowWidthWatcher() {
      this.updateSize();
    },
    'window.innerHeight': function windowHeightWatcher() {
      this.updateSize();
    },
    'window.mouseX': function windowWidthWatcher() {
      this.checkCollision();
    },
    'window.mouseY': function windowHeightWatcher() {
      this.checkCollision();
    },
  },
};
</script>

<style lang="scss" module>
.canvas {
  position: relative;
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>

<style>
html,
body {
  height: 100%;
}

body {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue